export default "__VITE_ASSET__CZ$JeeMl__"